import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { Eye, EyeOff, LogIn } from 'lucide-react'

const LoginPage = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const { user, login, isLoading, error, attemptsRemaining, accountBlocked, finalAttempt, clearError } = useAuthStore()

    useEffect(() => {
        clearError()
    }, [clearError])

    if (user) {
        return <Navigate to="/" replace />
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        await login(email, password)
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Sistema de Evidencias
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        Acreditación Universitaria
                    </p>
                </div>

                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="card">
                        <div className="space-y-4">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Correo Electrónico
                                </label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    required
                                    className="input-field mt-1"
                                    placeholder="nombre.apellido@uss.cl"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Contraseña
                                </label>
                                <div className="mt-1 relative">
                                    <input
                                        id="password"
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        required
                                        className="input-field pr-10"
                                        placeholder="••••••••"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? (
                                            <EyeOff className="h-4 w-4 text-gray-400" />
                                        ) : (
                                            <Eye className="h-4 w-4 text-gray-400" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {error && (
                            <div className={`mt-4 p-3 rounded ${
                                accountBlocked 
                                    ? 'bg-red-200 border-2 border-red-600 text-red-900' 
                                    : 'bg-red-100 border border-red-400 text-red-700'
                            }`}>
                                <div className="font-semibold">{error}</div>
                                {attemptsRemaining !== null && attemptsRemaining > 0 && !accountBlocked && (
                                    <div className="mt-2 text-sm">
                                        {finalAttempt ? (
                                            <span className="font-bold text-red-900">
                                                ⚠️ Este es tu último intento. Si fallas, tu cuenta será bloqueada.
                                            </span>
                                        ) : (
                                            <span>
                                                Intentos restantes: <strong>{attemptsRemaining}</strong>
                                            </span>
                                        )}
                                    </div>
                                )}
                                {accountBlocked && (
                                    <div className="mt-2 text-sm font-semibold">
                                        🔒 Debes contactar al administrador para desbloquear tu cuenta.
                                    </div>
                                )}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="mt-6 w-full btn-primary flex items-center justify-center space-x-2 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            ) : (
                                <>
                                    <LogIn className="h-4 w-4" />
                                    <span>Iniciar Sesión</span>
                                </>
                            )}
                        </button>

                        <div className="mt-4 text-center">
                            <p className="text-sm text-gray-600">
                                ¿Olvidaste tu contraseña?{' '}
                                <span className="text-blue-600 font-medium">
                                    Contacta al administrador del sistema
                                </span>
                            </p>
                            <p className="text-xs text-gray-500 mt-2">
                                El administrador puede reenviar tu contraseña desde la gestión de usuarios
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default LoginPage